import React, { useEffect, useState } from 'react';
import client from '../../api/client';

const TestimonialForm = () => {
	// State for each field in the form
	const [name, setName] = useState('');
	const [rating, setRating] = useState('');
	const [review, setReview] = useState('');
	const [link, setLink] = useState('');
	const [message, setMessage] = useState('');
	const [reviews, setReviews] = useState([]);
	// Handle form submission
	const handleSubmit = async (e) => {
		e.preventDefault();

		// Check if rating is within the acceptable range (1-5)
		const numericRating = Number(rating);
		if (!numericRating || numericRating < 1 || numericRating > 5) {
			setMessage('Rating must be a number between 1 and 5.');
			return;
		}

		try {
			const { data } = await client.post('/testimonials', {
				name,
				rating: numericRating,
				review,
				link,
			});

			setMessage('Testimonial submitted successfully!');
			setName('');
			setRating('');
			setReview('');
			setLink('');
		} catch (error) {
			setMessage('Error: ' + error.message);
		}
	};
	const fetchReviews = async () => {
		try {
			const { data } = await client.get('/testimonials');
			setReviews(data);
		} catch (error) {
			console.error('Error fetching reviews:', error);
		}
	};
	useEffect(() => {
		fetchReviews();
	}, []);
	return (
		<div className='flex items-center justify-center  bg-gray-100'>
			<div className='bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 w-full max-w-md'>
				<h2 className='text-2xl font-bold mb-6 text-center'>
					Submit Testimonial
				</h2>
				{message && <p className='mb-4 text-center text-red-500'>{message}</p>}
				<form onSubmit={handleSubmit}>
					<div className='mb-4'>
						<label
							htmlFor='name'
							className='block text-gray-700 font-bold mb-2'
						>
							Name:
						</label>
						<input
							type='text'
							id='name'
							name='name'
							value={name}
							onChange={(e) => setName(e.target.value)}
							placeholder='Enter your name'
							className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
						/>
					</div>
					<div className='mb-4'>
						<label
							htmlFor='rating'
							className='block text-gray-700 font-bold mb-2'
						>
							Rating (1-5):
						</label>
						<input
							type='number'
							id='rating'
							name='rating'
							value={rating}
							onChange={(e) => setRating(e.target.value)}
							min='1'
							max='5'
							required
							placeholder='Enter a rating'
							className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
						/>
					</div>
					<div className='mb-4'>
						<label
							htmlFor='review'
							className='block text-gray-700 font-bold mb-2'
						>
							Review:
						</label>
						<textarea
							id='review'
							name='review'
							value={review}
							onChange={(e) => setReview(e.target.value)}
							placeholder='Enter your review'
							className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
						></textarea>
					</div>
					<div className='mb-6'>
						<label
							htmlFor='link'
							className='block text-gray-700 font-bold mb-2'
						>
							Link:
						</label>
						<input
							type='url'
							id='link'
							name='link'
							value={link}
							onChange={(e) => setLink(e.target.value)}
							placeholder='Enter a link'
							className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
						/>
					</div>
					<div className='flex items-center justify-center'>
						<button
							type='submit'
							className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
						>
							Submit Testimonial
						</button>
					</div>
				</form>
			</div>
			<div className='ml-4'>
				<div className='bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 w-full max-w-md'>
					<h2 className='text-2xl font-bold mb-6 text-center'>Reviews</h2>
					<ul className='list-disc'>
						{reviews.map((review) => (
							<li
								key={review._id}
								className='mb-4'
							>
								<p>
									<strong>{review.Name}</strong> - {review.rating}/5
								</p>
								<p>{review.review}</p>
								<a
									href={review.link}
									target='_blank'
									rel='noopener noreferrer'
								>
									View Link
								</a>
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default TestimonialForm;
